import { ConnectedProps, connect } from "react-redux";
import { AppDispatch, RootState } from "store";
import { WorkzoneModal } from "./WorkzoneModal";
import { regionSelector, actions as regionsActions } from "reducers/regions";
import {
  UpdateWorkzoneCapacityPayloadType,
  WorkzoneUpdateType,
} from "sagas/types/regions";
import { WorkzoneModalContainerType } from "./types";
import { SubmitWorkzonesType } from "./types";
import { useEffect, useRef } from "react";
import { FormRefType } from "utils/types";
import { sessionSelector, actions as sessionActions } from "reducers/session";
import { actions as notificationActions } from "reducers/notification";
import { NotificationStateType } from "reducers/types/notification";
import { dirtyAlert } from "utils/alerts";

const WorkzoneModalContainer = (
  props: WorkzoneModalContainerType & ConnectorProps
): JSX.Element => {
  const formRef: FormRefType<any> = useRef(null);
  const onSubmit = (payload: SubmitWorkzonesType) => {
    const workzones = Object.entries(payload.workzones).map(([key, value]) => {
      const wk: WorkzoneUpdateType = { id: key, maxTransactions: value };
      return wk;
    });
    const body = { id: payload.id, workzones };
    props.updateWorkzoneCapacity(body);
  };

  const handleClose = () => {
    const close = () => {
      props.onClose();
      props.setDirty(false);
    };

    if (props.dirty) {
      props.showNotification(dirtyAlert({ onCancel: close, scroll: false }));
    } else {
      close();
    }
  };

  useEffect(() => {
    if (formRef.current) formRef.current.restart();
  }, [props.isOpen]);

  return <WorkzoneModal {...props} formRef={formRef} onSubmit={onSubmit} onClose={handleClose} />;
};

const mapStateToProps = (state: RootState) => ({
  actualRegion: regionSelector(state).actualRegion,
  dirty: sessionSelector(state).dirtyForm,
});

const mapDispatchToProps = (dispatch: AppDispatch) => ({
  updateWorkzoneCapacity: (params: UpdateWorkzoneCapacityPayloadType) => {
    dispatch(regionsActions.updateWorkzoneCapacityRequest(params));
  },
  setDirty: (dirty: boolean) => {
    dispatch(sessionActions.setDirty(dirty));
  },
  showNotification: (content: NotificationStateType) => {
    dispatch(notificationActions.showNotification(content));
  },
});

const connector = connect(mapStateToProps, mapDispatchToProps);

type ConnectorProps = ConnectedProps<typeof connector>;

export default connector(WorkzoneModalContainer);
